const TYPES = [
  {
    key: "home-care",
    label: "Home Care",
    blurb:
      "In-home personal care, companion care, and non-medical home support agencies serving aging adults.",
    image:
      "https://images.pexels.com/photos/7551613/pexels-photo-7551613.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Caregiver assisting elderly person warmly",
    span: "md:col-span-3 md:row-span-2",
  },
  {
    key: "assisted-living",
    label: "Assisted Living",
    blurb:
      "Licensed residential facilities — from small homes to larger communities.",
    image:
      "https://images.pexels.com/photos/7551630/pexels-photo-7551630.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Elderly couple in a warm living room",
    span: "md:col-span-3 md:row-span-1",
  },
  {
    key: "career-support",
    label: "Career Support — Re-Entry & Special Needs",
    blurb:
      "Programs supporting recently released individuals and adults with special needs into meaningful work.",
    image:
      "https://images.pexels.com/photos/7176302/pexels-photo-7176302.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Therapist in warm group discussion",
    span: "md:col-span-3 md:row-span-1",
  },
  {
    key: "sober-living",
    label: "Sober Living",
    blurb:
      "Recovery residences and structured sober living homes with strong community outcomes.",
    image:
      "https://images.unsplash.com/photo-1604881991720-f91add269bed?auto=format&fit=crop&w=1200&q=80",
    alt: "Two people holding hands on a table for support",
    span: "md:col-span-6 md:row-span-1",
  },
];

export default function BusinessTypes() {
  return (
    <section
      id="what-we-buy"
      data-testid="business-types-section"
      className="py-24 md:py-32 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div className="max-w-2xl">
            <span className="eyebrow">Sectors we actively acquire</span>
            <h2 className="font-serif-display text-4xl md:text-5xl tracking-tight mt-5 text-[#1A2621]">
              What we&rsquo;re looking
              <span className="italic text-[#284A3B]"> to buy.</span>
            </h2>
          </div>
          <p className="max-w-md text-[#4A5D54] leading-relaxed">
            We focus on care-driven businesses where continuity matters. If
            your operation fits one of these categories, we&rsquo;d like to
            talk.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-6 md:auto-rows-[230px] gap-5 md:gap-6">
          {TYPES.map((t, idx) => (
            <article
              key={t.key}
              data-testid={`business-type-${t.key}`}
              className={`relative group overflow-hidden rounded-2xl border border-[#D5DACF] bg-white ${t.span}`}
            >
              <img
                src={t.image}
                alt={t.alt}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A2621]/85 via-[#1A2621]/30 to-transparent" />
              <div className="relative z-10 h-full flex flex-col justify-end p-6 md:p-7 text-[#FDFBF7]">
                <div className="text-xs uppercase tracking-[0.22em] text-[#FDFBF7]/80">
                  0{idx + 1}
                </div>
                <h3 className="font-serif-display text-2xl md:text-3xl leading-tight mt-2">
                  {t.label}
                </h3>
                <p className="mt-3 text-sm md:text-base text-[#FDFBF7]/85 max-w-md leading-relaxed">
                  {t.blurb}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
